import { render, staticRenderFns } from "./SettingsParent.vue?vue&type=template&id=7e968a58&"
import script from "./SettingsParent.vue?vue&type=script&lang=js&"
export * from "./SettingsParent.vue?vue&type=script&lang=js&"
import style0 from "./SettingsParent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports